/* eslint-disable react/prop-types */
import React from 'react';
import Question from './Question';

const MessagesFrom = ({ projectId, variables, questionnaire }) => {
  const collectionId = 'f_message_templates';

  const questionsIds = [collectionId];

  questionnaire
    .getChildQuestions(collectionId)
    .forEach((question) => questionsIds.push(question.id));

  questionsIds.forEach((questionId) =>
    questionnaire
      .getChildQuestions(questionId)
      .forEach((question) => questionsIds.push(question.id)),
  );

  return (
    <Question
      projectId={projectId}
      variables={variables}
      questionnaire={questionnaire}
      questionsIds={questionsIds}
      nameId="f0_name"
      hasOrder
    />
  );
};

export default MessagesFrom;
